import { OktaAuth } from "@okta/okta-auth-js";
import { inject } from "@angular/core";
import { Router, UrlTree } from "@angular/router";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { OKTA_AUTH } from "@okta/okta-angular";

export function OktaAuthGuardFn(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const router: Router = inject(Router);
    const oktaAuth: OktaAuth = inject(OKTA_AUTH);

    return from(oktaAuth.isAuthenticated()).pipe(
        map((value: boolean) => {
            if (value) {
                return true;
            }
            router.navigate(["/session-expired"]);
            return false;
        }),
    );
}
